import { createSelector } from 'reselect'
import config from 'config'
import { localize } from 'helpers/translator'
import filterTypes from 'helpers/enums/filters/filterTypes'

const getStoreCategories = state => state.store.categories
const getStoreStandards = state => state.store.standard
const getSelectedFilters = state => state.store.selectedFilters
const getStateFilterSelected = state => state.store.stateFilterSelected

const storeFilterSidebarSelector = createSelector(
	[ getStoreCategories, getStoreStandards, getSelectedFilters, getStateFilterSelected ],
	(storeCategories, storeStandards, selectedFilters, stateFilterSelected) => {
		const categories = storeCategories.map(category => ({
			id: category.id,
			title: category.title,
			friendlyText: category.friendlyText,
			numColumns: category.id === config.categories.price ? 2 : 1,
			elements: category.items.map(element => ({
				...element,
				selected: selectedFilters.includes(element.entityUID),
			})),
		}))

		const standardCategory = storeStandards.find(standardCategory => standardCategory.filterType === filterTypes.STANDARDS_FILTER)
		const states = (standardCategory && standardCategory.items) ?
			standardCategory.items.map(item => ({
				value: item.entityUID,
				text: item.text,
			}))
			:
			[]

		// TODO: Remove when we add the clear standards button
		states.unshift({
			value: '',
			text: localize('standards_filter_placeholder'),
		})

		let subjects = []
		if (stateFilterSelected) {
			const stateCategory = standardCategory.items.find(standard => standard.entityUID === stateFilterSelected)
			subjects = (stateCategory.items) ? stateCategory.items[0].items : []
			subjects = subjects.map(item => ({
				...item,
				selected: false, // WIP: Will be completed when show grades in the standard filters
			}))
		}

		return {
			categories,
			standards: {
				states,
				subjects,
			},
		}
	}
)

export default storeFilterSidebarSelector
